import React from 'react'
import { Box, styled } from '@mui/material'
import { FullWidth } from '../Misc/FullWidth'
import { storyTypography } from '../../../tokens/typography-storybuilder'

type Props = {
  style?: React.CSSProperties
  backgroundColor?: string
  children: any
}
export const PrintBlockPublic = ({
  style,
  backgroundColor,
  children,
}: Props): JSX.Element => {
  return (
    <FullWidth backgroundColor={backgroundColor}>
      <Container style={style}>{children}</Container>
    </FullWidth>
  )
}

const Container = styled(Box)`
  max-width: 744px;
  margin: 0 auto;
  ${storyTypography.freeTextBlock.styles};
`
